
import lazyButton from './src/LazyButton.vue';

export const LazyButton = lazyButton
